import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const UserTypeHistoriesPage = lazy(() => import('../views/list/UserTypeHistoriesPage'));

export function UserTypeHistoriesPageLazy() {
	return (
		<PageSuspense>
			<UserTypeHistoriesPage />
		</PageSuspense>
	);
}
